import { cover, rem } from 'polished';
import styled from 'styled-components';

import { getAspectRatioRate } from '../../helpers';
import { IUserType } from '../../types';

export const StyledCard = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledCardCta = styled.button`
  display: flex;
  margin-top: ${rem('4px')};
  padding: ${rem('4px')} 0;
  font-size: ${rem('14px')};
  font-weight: 700;
  text-transform: uppercase;
  border: none;
  background: transparent;
  appearance: none;
  cursor: pointer;
`;

export const StyledCardImage = styled.img`
  ${cover()}
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const StyledCardImageOuterWrapper = styled.div`
  width: ${rem('119px')};
  flex-shrink: 0;
`;

export const StyledCardImageInnerWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: ${getAspectRatioRate(119, 86)};
  border-radius: ${rem('8px')};
  overflow: hidden;
`;

export const StyledCardText = styled.div<IUserType>`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  margin-left: ${rem('16px')};

  ${StyledCardCta} {
    color: ${({ theme, user }) => user && theme.colors[user].main};
  }
`;

export const StyledCardTitle = styled.span`
  display: block;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: 600;
`;

export const StyledCardInnerTitle = styled.span`
  display: block;
  margin-bottom: ${rem('32px')};
  color: ${({ theme }) => theme.colors.main};
  font-size: ${rem('20px')};
  font-weight: 300;
  text-align: center;
`;

export const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
`;

export const StyledListItem = styled.li`
  list-style: none;

  &:not(:first-child) {
    margin-top: ${rem('16px')};
  }
`;

export const StyledModalPanelInnerWrapper = styled.div`
  padding: ${rem('48px')} ${rem('16px')} ${rem('32px')};
`;

export const StyledLink = styled.a`
  display: inline-flex;
  padding: ${rem('8px')} 0;
  color: inherit;
  text-decoration: none;
`;

export const StyledLinkList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const StyledLinkListItem = styled.li`
  color: ${({ theme }) => theme.colors.main};
  font-size: ${rem('14px')};
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  list-style: none;

  &:not(:first-child) {
    margin-top: ${rem('8px')};
  }
`;

export const StyledWrapper = styled.div``;
